import React, { useRef, useState, useEffect } from "react";

interface AudioPlayerProps {
  src: string;
}

const AudioPlayer: React.FC<AudioPlayerProps> = ({ src}) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
    }
  };

  const handleProgressChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (audioRef.current) {
      const newTime = Number(event.target.value);
      audioRef.current.currentTime = newTime;
      setCurrentTime(newTime);
    }
  };

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.addEventListener("timeupdate", handleTimeUpdate);
      audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    }
    return () => {
      if (audio) {
        audio.removeEventListener("timeupdate", handleTimeUpdate);
        audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
      }
    };
  }, []);

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <div style={{ textAlign: "center" }}>
      <audio ref={audioRef} src={src} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <button
          onClick={handlePlayPause}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            fontSize: "24px",
          }}
        >
          <i
            className={isPlaying ? "fas fa-pause" : "fas fa-play"}
            style={{ color: isPlaying ? "red" : "green" }}
          ></i>
        </button>
        <input
          type="range"
          min={0}
          max={duration}
          value={currentTime}
          onChange={handleProgressChange}
          style={{
            flex: 1,
            appearance: "none",
            height: "8px",
            background: "#ddd",
            borderRadius: "5px",
            outline: "none",
            margin: "0 10px",
          }}
        />
        <style>
          {`
            input[type="range"] {
              -webkit-appearance: none; /* Override default CSS styles */
              width: 100%; /* Full-width */
            }

            input[type="range"]::-webkit-slider-thumb {
              -webkit-appearance: none;
              appearance: none;
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background: #4CAF50; /* Green color */
              cursor: pointer;
              box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
              margin-top: -4px; /* Center the thumb */
            }

            input[type="range"]::-moz-range-thumb {
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background: #4CAF50; /* Green color */
              cursor: pointer;
              box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
            }

            input[type="range"]::-ms-thumb {
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background: #4CAF50; /* Green color */
              cursor: pointer;
              box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
            }

            input[type="range"]::-webkit-slider-runnable-track {
              height: 8px;
              background: #ddd;
 border-radius: 5px;
            }

            input[type="range"]::-moz-range-track {
              height: 8px;
              background: #ddd;
              border-radius: 5px;
            }

            input[type="range"]::-ms-track {
              height: 8px;
              background: #ddd;
              border-radius: 5px;
              border: none;
              color: transparent;
            }
          `}
        </style>
      </div>
      <div>
        <span>
          {formatTime(currentTime)} / {formatTime(duration)}
        </span>
      </div>
    </div>
  );
};

export default AudioPlayer;
